import {Component, ElementRef, inject, signal} from '@angular/core';
import {BaseRecordTableItemComponent} from "../base-record-table-item/base-record-table-item.component";
import {RecordDataValue} from "../../../../types/records-table.types";
import {smoothShowHideHeight} from "../../../../../shared/animations/smoothShowHideAnimations";

@Component({
  selector: 'app-photo-table-item',
  standalone: false,
  templateUrl: './photo-table-item.component.html',
  styleUrl: './photo-table-item.component.scss',
  animations: [ smoothShowHideHeight ]
})
export class PhotoTableItemComponent extends BaseRecordTableItemComponent {
  private elementRef: ElementRef = inject(ElementRef);

  public isCustomTooltipShowed = signal(false);
  public tooltipPosition = signal<'bottom' | 'top'>('bottom');

  public previewWidth: number = 200;
  public previewHeight: number = 200;

  public getClass(): string {
    const classes = this.isEdit && !this.isEditable ? 'disabled-control' : '';
    return !this.isPossibleToEdit() ? `${classes} pointer` : `${classes}`;
  }

  public isImageAvailable(): boolean {
    return !!this.value;
  }

  public handleValueClick(value: RecordDataValue): void {
    if (!this.isImageAvailable()) { return; }

    window.open(value as string, '_blank')?.focus();
  }

  public showCustomTooltip(): void {
    if (!this.isImageAvailable()) { return; }
    const rect = (this.elementRef.nativeElement as HTMLElement).getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const tooltipHeight = 250;

    this.tooltipPosition.set(spaceBelow > tooltipHeight ? 'bottom' : 'top');
    this.isCustomTooltipShowed.set(true);
  }

  public hideCustomTooltip(): void {
    this.isCustomTooltipShowed.set(false);
  }
}
